<template>
  <div>
    <el-dialog
      :title="historyPlanData.title"
      :visible.sync="historyPlanData.show"
      width="1000px"
      center
    >
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="Id"
          align="center"
          label="ID"
        ></el-table-column>
        <el-table-column
          prop="Name"
          align="center"
          :label="$t('Proposal')"
        ></el-table-column>
        <el-table-column
          prop="ModelId"
          align="center"
          :label="$t('CommissionCalculationModel')"
        ></el-table-column>
        <el-table-column
          prop="cycle"
          align="center"
          :label="$t('CommissionDisbursementPeriod')"
        ></el-table-column>
        <el-table-column
          prop="CreateTime"
          align="center"
          label="方案变更时间"
        ></el-table-column>
        <el-table-column align="center"  :label="$t('Actions')">
          <template slot-scope="scope">
            <el-button @click="showDetail(scope.row)" type="text"
              >方案详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 详情显示 -->
    <plan v-if="planData.show" :planData="planData"></plan>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
import plan from "./plan.vue";
export default {
  extends: base,
  components: { plan },
  props: {
    historyPlanData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      planData: {
        show: false,
        title: $t('CreateProposal'),
        type: "",
        rowData: {},
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const data = {
        SellerId:
          this.historyPlanData.rowData.SellerId || this.filters.SellerId,
        UserId: Number(this.historyPlanData.rowData.UserId),
      };
      this.loading = true;
      app.post(
        "/agent/agent_fangan_record",
        data,
        (res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.tableData.forEach((item) => {
              item.ModelId = "全民无限";
              item.cycle = "日";
              item.Name = JSON.parse(item.Data).Name;
            });
            this.loading = false;
          } else {
            this.loading = false;
          }
        },
        true
      );
    },
    showDetail(row) {
      this.planData.show = true;
      this.planData.type = 3;
      this.planData.title = "方案详情";
      this.planData.rowData = JSON.parse(row.Data);
    },
  },
};
</script>

<style lang="scss" scoped></style>
